import {redirectTo} from 'BenchlingUtil';
import notifications, {NotificationOptions} from 'notifications';
import uniqueId from 'util/uniqueId';

export const EXPORT_SUCCESS_MESSAGE = 'Export complete. Downloading...';

export interface ExportWithNotificationInput {
  url: string;
  message?: string;
  notificationOptions?: NotificationOptions;
}

export default async function exportWithNotification(
  doExport: () => Promise<ExportWithNotificationInput>,
  pendingMessage: string = 'Exporting...'
): Promise<void> {
  const notificationId = uniqueId('export-');
  notifications.info(pendingMessage, {id: notificationId, duration: 0});
  const {url, message, notificationOptions} = await doExport();
  redirectTo(url);
  notifications.success(message ?? EXPORT_SUCCESS_MESSAGE, {
    id: notificationId,
    ...notificationOptions,
  });
}
